var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17193 7.87943C8.71466 7.87943 8.27611 8.06108 7.95278 8.38442C7.62944 8.70775 7.44779 9.1463 7.44779 9.60357V33.7415C7.44779 34.1988 7.62944 34.6373 7.95278 34.9606C8.27611 35.284 8.71466 35.4656 9.17193 35.4656H16.0685C17.0207 35.4656 17.7926 36.2376 17.7926 37.1898C17.7926 38.142 17.0207 38.9139 16.0685 38.9139H9.17193C7.80012 38.9139 6.48449 38.369 5.51448 37.3989C4.54446 36.4289 3.99951 35.1133 3.99951 33.7415V9.60357C3.99951 8.23176 4.54446 6.91613 5.51448 5.94612C6.48449 4.9761 7.80012 4.43115 9.17193 4.43115H16.0685C17.0207 4.43115 17.7926 5.20308 17.7926 6.15529C17.7926 7.10751 17.0207 7.87943 16.0685 7.87943H9.17193Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9181 11.8326C27.5914 11.1593 28.6831 11.1593 29.3564 11.8326L37.9771 20.4533C38.6504 21.1266 38.6504 22.2183 37.9771 22.8916L29.3564 31.5123C28.6831 32.1856 27.5914 32.1856 26.9181 31.5123C26.2448 30.839 26.2448 29.7473 26.9181 29.074L34.3196 21.6725L26.9181 14.2709C26.2448 13.5976 26.2448 12.5059 26.9181 11.8326Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3447 21.6724C14.3447 20.7202 15.1166 19.9482 16.0689 19.9482H36.7585C37.7107 19.9482 38.4827 20.7202 38.4827 21.6724C38.4827 22.6246 37.7107 23.3965 36.7585 23.3965H16.0689C15.1166 23.3965 14.3447 22.6246 14.3447 21.6724Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.15d3fd8f47a16ba6687e8b4a5e4fd930.svg";
export { ForwardRef as ReactComponent };